module.exports = __webpack_public_path__ + "static/media/info-circle.99216f31.svg";